import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { GeoImagesViewTopBar } from "./TopBar"

export const imagesViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: GeoImagesViewTopBar,
}
